(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', './SiteLinks', './SupportLinks', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('./SiteLinks'), require('./SupportLinks'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.SiteLinks, global.SupportLinks, global.propTypes);
    global.Drawer = mod.exports;
  }
})(this, function (exports, _react, _SiteLinks, _SupportLinks, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _SiteLinks2 = _interopRequireDefault(_SiteLinks);

  var _SupportLinks2 = _interopRequireDefault(_SupportLinks);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Drawer = function (_React$Component) {
    _inherits(Drawer, _React$Component);

    function Drawer(props) {
      _classCallCheck(this, Drawer);

      var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));

      _this.state = {
        windowHeight: 0,
        windowWidth: 0,
        windowZIndex: -10
      };
      return _this;
    }

    _createClass(Drawer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.setState({
          windowHeight: this.drawerContainer.offsetHeight + 'px',
          windowWidth: this.drawerContainer.offsetWidth + 'px'
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(
          'div',
          {
            className: 'col-sm-12 col-lg-6 col-md-7 header-drawer',
            onClick: this.props.handleBubble,
            style: this.props.isMobile ? {
              overflowY: 'scroll',
              overflowX: 'hidden',
              right: this.props.open ? this.props.isMobile ? '0' : this.state.windowWidth : -280,
              transition: this.props.open ? 'all .3s ease-in-out' : '0',
              zIndex: -10,
              position: 'fixed',
              background: '#000',
              width: this.props.open ? this.props.isMobile ? '60%' : this.state.windowWidth : 0,
              height: '100%',
              padding: '0'
            } : {
              padding: '0',
              width: 'auto'
            }
          },
          _react2.default.createElement(
            'div',
            {
              className: 'drawer-container',
              style: {
                padding: this.props.isMobile ? '70px 0 0 0' : '0'
              },
              ref: function ref(container) {
                _this2.drawerContainer = container;
              }
            },
            _react2.default.createElement(_SiteLinks2.default, {
              links: this.props.siteLinks,
              isMobile: this.props.isMobile
            }),
            _react2.default.createElement(_SupportLinks2.default, {
              links: this.props.supportLinks,
              isMobile: this.props.isMobile,
              mobileAppText: this.props.mobileAppText
            }),
            _react2.default.createElement('div', { className: 'clearfix' })
          )
        );
      }
    }]);

    return Drawer;
  }(_react2.default.Component);

  exports.default = Drawer;


  Drawer.propTypes = {
    siteLinks: _propTypes2.default.array,
    supportLinks: _propTypes2.default.array,
    socialLinks: _propTypes2.default.array,
    open: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    handleBubble: _propTypes2.default.func,
    mobileAppText: _propTypes2.default.object
  };

  Drawer.defaultProps = {
    siteLinks: [],
    supportLinks: [],
    open: false
  };
});